var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayment = function SvgPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 32.5,
    fill: "#fff",
    stroke: "#a2bc3a",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1d490f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 17c-9.93 0-18 8.07-18 18s8.07 18 18 18 18-8.07 18-18-8.07-18-18-18zm0 34.2c-8.93 0-16.2-7.27-16.2-16.2S26.07 18.8 35 18.8 51.2 26.07 51.2 35 43.93 51.2 35 51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.62 34c-2.8-1.1-4.5-1.9-4.5-3.67 0-2.37 2.16-3.45 4.16-3.45 1.08 0 2.11.31 2.84.86a2.85 2.85 0 0 1 1.16 2.39.9.9 0 1 0 1.8 0c0-3.08-2.51-4.79-5.18-5.02V23.3a.9.9 0 1 0-1.8 0v1.88a6.34 6.34 0 0 0-2.84 1.17 4.82 4.82 0 0 0-1.94 3.98c0 3.14 3 4.3 5.65 5.34 2.87 1.12 4.61 1.93 4.61 3.82a3.2 3.2 0 0 1-1.29 2.7c-.8.6-1.9.93-3.12.93-2.36 0-4.76-1.3-4.76-3.78a.9.9 0 1 0-1.8 0c0 3.26 2.62 5.13 5.49 5.5v1.86a.9.9 0 1 0 1.8 0v-1.82a6.77 6.77 0 0 0 3.48-1.26c1.3-1 2-2.42 2-4.13 0-3.25-3.06-4.45-5.76-5.5z"
  }))));
};
export default SvgPayment;